















import Vue from 'vue';
import {
  buyer,
  Buyer,
  buyerCompany as company,
  BuyerCompany as Company,
} from 'mostra';

interface DataType {
  owner: string | null;
  buyer: Buyer | null;
  company: Company | null;
  loading: boolean;
  notFound: boolean;
}
export default Vue.extend({
  name: 'buyer-settings-company',
  data(): DataType {
    return {
      buyer: null,
      company: null,
      loading: true,
      notFound: false,
      owner: null,
    };
  },
  methods: {
    async toUpdateData() {
      if (!this.buyer) return;
      try {
        this.$loading(true);
        const uid = this.$auth.uid;
        const buyerSaveRes = await buyer.save(uid, this.buyer);
        this.buyer = buyerSaveRes;
        this.$success('保存しました。');
      } catch (error: any) {
        this.$error('保存に失敗しました。', error);
      } finally {
        this.$loading(false);
      }
    },
    async fetchData() {
      try {
        this.loading = true;
        this.$loading(true);
        this.owner = this.$auth.cid;
        const uid = this.$auth.uid;
        this.buyer = await buyer.load(uid);
        this.company = await company.loadByOwner(uid);
        if (!this.buyer || !this.company) {
          this.notFound = true;
          return;
        }
      } catch (error: any) {
        this.$fatal(error);
      } finally {
        this.loading = false;
        this.$loading(false);
      }
    },
  },
  async beforeRouteUpdate(to, from, next) {
    next();
    await this.fetchData();
  },
  async mounted() {
    await this.fetchData();
  },
});
